import { defaultInternalLogger } from "./const.js";
import { createInternalLogger } from "./createInternalLogger.js";
//#region src/internalLogger/initialize.ts
let internalLogger = defaultInternalLogger;
function initializeInternalLogger(unpatchedConsole, config) {
	internalLogger = createInternalLogger(unpatchedConsole, config.internalLoggerLevel);
	return internalLogger;
}
//#endregion
export { initializeInternalLogger, internalLogger };

//# sourceMappingURL=initialize.js.map